export default __webpack_public_path__ + "static/our-vision-2-d512375c1d16ddd642bacbff80c8d8f0.svg";